import { render, staticRenderFns } from "./bdPlan.vue?vue&type=template&id=2020761e&scoped=true"
import script from "./bdPlan.vue?vue&type=script&lang=js"
export * from "./bdPlan.vue?vue&type=script&lang=js"
import style0 from "./bdPlan.vue?vue&type=style&index=0&id=2020761e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020761e",
  null
  
)

export default component.exports